import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./i18next/i18n";
import { configureStore } from "./redux/store";

ReactDOM.render(
  <Provider store={configureStore()}>
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  </Provider>,
  document.getElementById("root"),
);
